import { render } from "./textset.vue?vue&type=template&id=c09a4c5c&scoped=true"
import script from "./textset.vue?vue&type=script&lang=js"
export * from "./textset.vue?vue&type=script&lang=js"

import "./textset.vue?vue&type=style&index=0&id=c09a4c5c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09a4c5c"]])

export default __exports__